<template>
	<page-container :page="page" :locale="locale">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<promoblocks :items="page.promoblocks" />
		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
		<div class="zc-widget-config" data-restaurant="383147" data-open="2000" :data-lang="locale"></div>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();
useZenchef();
useRemoveGifty();
</script>
